import { APP_BASE_PATHS, APP_EXTERNAL_BASE_PATHS } from '../../constants/app-paths';
import APP_RENDER_MODES from '../../constants/app-render-modes';

// Exports
// -------

export default function getBasePathAttributes() {
  const currentPath = window.location.pathname;

  if (currentPath.includes(APP_BASE_PATHS.chromeless)) {
    return {
      basePath: APP_BASE_PATHS.chromeless,
      renderMode: APP_RENDER_MODES.chromeless,
    };
  }

  if (currentPath.includes(APP_BASE_PATHS.uxp)) {
    return {
      basePath: APP_BASE_PATHS.uxp,
      externalBasePath: APP_EXTERNAL_BASE_PATHS.uxp,
      renderMode: APP_RENDER_MODES.uxp,
    };
  }

  return {
    basePath: APP_BASE_PATHS.default,
    renderMode: APP_RENDER_MODES.default,
  };
}
